module.exports = __webpack_public_path__ + "img/水系综合管控平台.77c7499a.jpg";